<template>
    <div class="diagram-hand-list">
        <div v-for="itemData in diagramItemList" :key="itemData.index" class="diagram-hand-c-item">
            <div class="diagram-hand-i-title">{{itemData.text}}</div>
            <div class="diagram-hand-choose-box" @click="clickHandItem(itemData)">
                <span v-if="choosedLineData[itemData.value] == 0" class="diagram-hand-choose-text1">请选择</span>
                <diagram-hand-item v-else :itemType="lineTypeList[choosedLineData[itemData.value]]"></diagram-hand-item>
                <span class="diagram-hand-choose-icon"><i class="iconfont icon-down"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
import DiagramHandItem from '../../components/diagram/DiagramHandItem.vue';
export default {
    name: 'DiagramHandList',
    components: { DiagramHandItem },
    props: {
        parentNode: {
            type: Object,
            default() { }
        } 
    },
    computed: {
        choosedLineData() {
            return this.$store.state.diagram.choosedLineData;
        },
        choosedLineValue() {
            return this.$store.state.diagram.choosedLineValue;
        }
    },
    data() {
        return {
            diagramItemList: [
                {index: 0, text: '六爻', value: 'six'},
                {index: 1, text: '五爻', value: 'five'},
                {index: 2, text: '四爻', value: 'four'},
                {index: 3, text: '三爻', value: 'three'},
                {index: 4, text: '二爻', value: 'two'},
                {index: 5, text: '一爻', value: 'one'}
            ],
            lineTypeList: ['', 'syin', 'syang', 'lyin', 'lyang']
        }
    },
    mounted: function() {

    },
    methods: {
        clickHandItem(itemData) {
            this.$store.state.diagram.curChoosedLine = itemData.value;
            this.$store.state.diagram.choosedLineValue = this.$store.state.diagram.choosedLineData[itemData.value];
            this.$store.state.diagram.showChooseLine = true;
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                this.$store.state.diagram.diagramTypeDataChanged = true;
            }
        }
    }
}
</script>